export const TRANSLATION_LOADING_PHRASES = [
  'translation.loading.analyzingContent',
  'translation.loading.extractingText',
  'translation.loading.understandingContext',
  'translation.loading.translatingCopy',
  'translation.loading.preservingIdentity',
  'translation.loading.matchingFonts',
  'translation.loading.generatingAssets',
  'translation.loading.ensuringConsistency',
  'translation.loading.fineTuning',
  'translation.loading.polishingResult',
  'translation.loading.almostThere',
] as const;

export const TRANSLATION_LOADING_PHRASES_DEFAULTS: Record<string, string> = {
  'translation.loading.analyzingContent': 'Analyzing your content...',
  'translation.loading.extractingText': 'Extracting text from images...',
  'translation.loading.understandingContext': 'Understanding brand context...',
  'translation.loading.translatingCopy': 'Translating copy...',
  'translation.loading.preservingIdentity': 'Preserving visual identity...',
  'translation.loading.matchingFonts': 'Matching font styles...',
  'translation.loading.generatingAssets': 'Generating translated assets...',
  'translation.loading.ensuringConsistency': 'Ensuring brand consistency...',
  'translation.loading.fineTuning': 'Fine-tuning translations...',
  'translation.loading.polishingResult': 'Polishing the final result...',
  'translation.loading.almostThere': 'Almost there...',
};
